import { v4 as uuid } from 'uuid';

export interface RRIBaseModel {
  id?: uuid;
}
